module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('breadcrumbs-layout', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbs,
      "wide": true
    }
  }, [(_vm.points && _vm.points.length < _vm.filtered && _vm.limited) ? _c('map-notification', [_vm._v("Количество отображаемых на карте объектов ограничено."), _c('template', {
    slot: "small"
  }, [_vm._v("Отображение всех объектов может существенно повлиять на скорость работы сайта!")]), _c('ext-button', {
    attrs: {
      "slot": "action",
      "size": "small",
      "factor": 1.2,
      "fill": false,
      "to": _vm.unlimitedRoute
    },
    slot: "action"
  }, [_vm._v("Показать все")])], 2) : _vm._e(), _c('map-page-layout', {
    attrs: {
      "points": _vm.hasCoords,
      "filtered": _vm.filtered,
      "updateEvents": _vm.updateEvents
    }
  }, [_c('filter-yellow', {
    key: JSON.stringify(_vm.filterValues),
    attrs: {
      "slot": "filter",
      "route": "map",
      "fields": _vm.filterFields,
      "values": _vm.filterValues,
      "nav": _vm.navSwitcher
    },
    slot: "filter"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-789435d2","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/event/map/Map.vue
// module id = 63b63c4e24aac1d2ec90
// module chunks = 88